import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgGlobe = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M9.475 3.094C8.803 1.728 8.181 1.5 8 1.5s-.803.228-1.475 1.594c-.531 1.078-.913 2.55-1.003 4.156h4.956c-.094-1.61-.475-3.081-1.003-4.156m1.003 5.656H5.522c.094 1.61.475 3.081 1.003 4.156C7.197 14.272 7.819 14.5 8 14.5s.803-.228 1.475-1.594c.531-1.078.912-2.55 1.003-4.156m1.503-1.5h2.475a6.51 6.51 0 0 0-3.837-5.2c.75 1.338 1.26 3.2 1.362 5.2m2.475 1.5h-2.475c-.103 2-.612 3.863-1.362 5.2a6.51 6.51 0 0 0 3.837-5.2m-10.437 0H1.544a6.51 6.51 0 0 0 3.837 5.2c-.75-1.337-1.26-3.2-1.362-5.2m-2.475-1.5h2.475c.103-2 .612-3.862 1.362-5.2a6.51 6.51 0 0 0-3.837 5.2M8 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGlobe);
export default ForwardRef;
